import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { Field, FieldArray, reduxForm, SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'

import { fetchOperator, updateOperator } from '../actions/operators'
import { fetchCalendarsName } from '../actions/calendars'
import { renderInputField, renderSelectField } from '../utils/forms'
import { fetchRules } from '../actions/rules'
import '../styles/FormModals.css'

class OperatorEditForm extends React.Component {
       constructor(props) {
              super(props)

              this.state = {
                     loaded: false
              }

              this.load = this.load.bind(this)
              this.submit = this.submit.bind(this)
       }

       componentDidMount() {
              const { fetchCalendarsName, fetchRules, fetchOperator, match } = this.props

              // In route mode the operator is fetched from the URL param;
              // in modal mode it is already in the store (loaded by the details view).
              if (match && match.params && match.params.id) {
                     fetchOperator(match.params.id)
              }
              fetchCalendarsName();
              fetchRules();

              this.load(this.props)
       }

       componentWillReceiveProps(nextProps) {
              this.load(nextProps)
       }

       load(props) {
              const { operator, calendars, rules, initialize } = props;

              if (!this.state.loaded && operator && calendars && rules) {
                     this.setState({
                            loaded: true
                     });
                     initialize(operator);  // Initialize form with operator data
              }
       }

       submit(props) {
              const { updateOperator, operator } = this.props;

              return updateOperator(operator._id, props).then((response) => {
                     if (response.error) {
                            throw new SubmissionError({
                                   _error: response.error.message,
                                   ...response.error.fields,
                            });
                     }

                     // If in modal mode, close modal and refresh the operator
                     if (this.props.isModal) {
                            this.props.closeModal();
                            if (this.props.refreshOperator) {
                                   this.props.refreshOperator();
                            }
                     }

                     return response;
              });
       }


       renderRules(props, rules) {
              const { fields } = props;

              const handleAddRule = () => {
                     fields.push({});
              };

              return (
                     <div>
                            <div className="opform-rules">
                                   {fields.map((registerrule, index) => (
                                          <div className="opform-rule-row" key={index}>
                                                 <span className="opform-rule-index">{index + 1}</span>
                                                 <div className="opform-rule-field">
                                                        <Field
                                                               name={`${registerrule}.BusinessRule`}
                                                               component={renderSelectField}
                                                        >
                                                               {rules &&
                                                                      rules
                                                                             .sort((a, b) => a.Name.localeCompare(b.Name))
                                                                             .map((rule) => (
                                                                                    <option value={rule._id} key={rule._id}>
                                                                                           {rule.Name}
                                                                                    </option>
                                                                             ))}
                                                        </Field>
                                                 </div>
                                                 <button
                                                        className="opform-rule-remove"
                                                        type="button"
                                                        onClick={() => fields.remove(index)}
                                                 >
                                                        <i className="fas fa-trash"></i>
                                                 </button>
                                          </div>
                                   ))}
                            </div>
                            <div className="text-right">
                                   <button
                                          className="btn btn-vw opform-add-rule"
                                          type="button"
                                          onClick={handleAddRule}
                                   >
                                          <i className="fas fa-plus mr-1"></i>
                                          Añadir
                                   </button>
                            </div>
                     </div>
              );
       }

       render() {
              const { operator, calendars, error, pristine, submitting, handleSubmit, rules, isModal } = this.props
              const { loaded } = this.state

              if (!loaded || !operator || !calendars || !rules) {
                     return (
                            <LoadingProgress />
                     )
              }

              return (
                     <form className="opform" onSubmit={handleSubmit(this.submit)}>
                            {!isModal && (
                                   <h1>
                                          <span className="text-vw-dark">EDITAR </span>
                                          <span className="text-vw-light">AGREGADOR</span>
                                   </h1>
                            )}

                            <div className="opform-section">
                                   <div className="opform-section-title">
                                          <i className="fas fa-handshake"></i>
                                          Agregador
                                   </div>
                                   <div className="opform-grid">
                                          <Field name="Name"
                                                 type="text"
                                                 component={renderInputField}
                                                 label="Nombre del agregador" />
                                          <Field name="InvoiceType"
                                                 component={renderSelectField}
                                                 label="Modelo de faturación">
                                                 <option value="">Selecciona un modo...</option>
                                                 <option value="Invoice">Factura</option>
                                                 <option value="Note">Albarán</option>
                                                 <option value="Free">No Contable</option>
                                          </Field>
                                          <Field name="External"
                                                 component={renderSelectField}
                                                 label="Agregador de canal propio Baqueira?">
                                                 <option value="">Selecciona una opción...</option>
                                                 <option value="true">SI</option>
                                                 <option value="false">NO</option>
                                          </Field>
                                          <Field name="Comission"
                                                 type="number"
                                                 component={renderInputField}
                                                 label="Comisión" />
                                          <Field name="Nif"
                                                 type="text"
                                                 component={renderInputField}
                                                 label="NIF/CIF" />
                                          <Field name="Country"
                                                 type="text"
                                                 component={renderInputField}
                                                 label="País" />
                                   </div>
                                   <Field name="Address"
                                          type="text"
                                          component={renderInputField}
                                          label="Dirección" />
                            </div>

                            <div className="opform-section">
                                   <div className="opform-section-title">
                                          <i className="fas fa-calendar-alt"></i>
                                          Calendario de precios
                                   </div>
                                   <Field name="Calendar"
                                          component={renderSelectField}
                                          label="Calendario de precios"
                                   >
                                          {calendars &&
                                                 calendars
                                                        .sort((a, b) => a.Name.localeCompare(b.Name))
                                                        .map((calendar) => (
                                                               <option value={calendar._id} key={calendar._id}>
                                                                      {calendar.Name}
                                                               </option>
                                                        ))}
                                   </Field>
                            </div>

                            <div className="opform-section">
                                   <div className="opform-section-title">
                                          <i className="fas fa-pencil-ruler"></i>
                                          Reglas de negocio
                                   </div>
                                   <FieldArray name="BusinessRules" component={(fieldArrayProps) => this.renderRules(fieldArrayProps, rules)} />
                            </div>

                            {error && <div className="alert alert-danger">{error}</div>}

                            {!isModal && (
                                   <button className="btn btn-vw opform-submit" type="submit"
                                          disabled={pristine || submitting}>
                                          <i className="fas fa-save mr-2"></i>
                                          Guardar
                                   </button>
                            )}
                            {isModal && (
                                   <div className="opform-footer">
                                          <button
                                                 className="btn btn-secondary"
                                                 type="button"
                                                 onClick={this.props.closeModal}>
                                                 <i className="fas fa-times mr-2"></i>
                                                 Cancelar
                                          </button>
                                          <button
                                                 className="btn btn-vw"
                                                 type="submit"
                                                 disabled={pristine || submitting}>
                                                 <i className="fas fa-save mr-2"></i>
                                                 Guardar
                                          </button>
                                   </div>
                            )}
                     </form>
              )
       }
}

OperatorEditForm = reduxForm({
       form: 'OperatorEditForm',
       keepDirtyOnReinitialize: true,
       enableReinitialize: true,
       updateUnregisteredFields: true,
       onSubmitSuccess: (result, dispatch, props) => {
              // Only push to route if NOT in modal mode
              if (!props.isModal) {
                     props.push(`/operators/${result.response._id}`)
              }
       }
})(OperatorEditForm)

const mapStateToProps = state => {
       return {
              operator: state.operators.operator,
              calendars: state.calendars.calendars,
              rules: state.rules.rules,
              initialValues: state.operators.operator,
       }
}

const mapDispatchToProps = dispatch => ({
       updateOperator: bindActionCreators(updateOperator, dispatch),
       fetchCalendarsName: bindActionCreators(fetchCalendarsName, dispatch),
       fetchOperator: bindActionCreators(fetchOperator, dispatch),
       fetchRules: bindActionCreators(fetchRules, dispatch),
       push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(OperatorEditForm)
